module.exports = __webpack_public_path__ + "img/ic_delete.32956b05.svg";